import React from 'react';

import Util from '$utilities';
import Header from '$partials/global/header';
import Footer from '$partials/global/footer';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').ErrorPage}
 */
const ErrorPage = (props) => {
    const status = Util.try(() => props.err.statusCode) || 500;

    let message = '';
    switch(status) {
        case 404:
            message = props.data.page?.heading404 || 'Page not found';
            break;

        default:
            message = props.data.page?.heading500 || 'Sorry, something went wrong.';
    }

    const page = props.data.page;
    const navigation = props.data?.navigation || {};
    const footer = props.data?.footer || {};
    const newsletter = props.data?.newsletter || {};
    const header = props.data?.header || {};
    const signate = props.data?.signate || {};

    const propertyListing = props.data?.propertyListing;
    const rentalPropertyListing = props.data?.rentalPropertyListing;

    return (
        <>
            <Header
                logo={header?.logo}
                pageType={page?.__typename}
                propertyListing={propertyListing}
                rentalPropertyListing={rentalPropertyListing}
                signate={signate?.signate}
                {...navigation}/>
            <main className='container'>
                <section>
                    <p className='type-style-5'>{message}</p>
                    <h1 className='type-style-1'>{status}</h1>
                </section>
            </main>
            <Footer
                {...footer}
                hubspot={props.hubspot}
                newsletter={newsletter}
                page={page}
                signate={signate?.signate}/>
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ErrorPage;
